import React from "react";

import YesNo from "components/views/YesNo";
import { useNavigate, useLocation } from "react-router-dom";

const CatalystFitted = () => {
  const location = useLocation();
  const navigate = useNavigate();

  function onYes() {
    navigate(`/results${location.search}&catalyst=true`);
  }

  function onNo() {
    navigate(`/results${location.search}&catalyst=false`);
  }

  return <YesNo onYes={onYes} onNo={onNo} />;
};

export default CatalystFitted;
